import { ref } from "vue";

type ToastType = "success" | "error" | "info";

interface ToastState {
  visible: boolean;
  message: string;
  type: ToastType;
}

const state = ref<ToastState>({
  visible: false,
  message: "",
  type: "info",
});

let timeoutId: ReturnType<typeof setTimeout> | null = null;

export function useToast() {
  const show = (message: string, type: ToastType = "info", duration = 3000) => {
    // Clear any existing timeout
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    state.value = {
      visible: true,
      message,
      type,
    };

    // Auto-hide after duration
    if (duration > 0) {
      timeoutId = setTimeout(() => {
        hide();
      }, duration);
    }
  };

  const hide = () => {
    state.value.visible = false;
  };

  const success = (message: string, duration = 3000) => {
    show(message, "success", duration);
  };

  const error = (message: string, duration = 4000) => {
    show(message, "error", duration);
  };

  const info = (message: string, duration = 3000) => {
    show(message, "info", duration);
  };

  return {
    state,
    show,
    hide,
    success,
    error,
    info,
  };
}
